import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useToast } from '../../contexts/ToastContext';
import { api } from '../../services/api';

function ContactSupportPage() {
  const { addToast } = useToast();
  const navigate = useNavigate();
  const { t } = useTranslation('settings');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!subject.trim() || !message.trim()) {
      addToast(t('support.fillBoth'), 'error');
      return;
    }
    setIsSubmitting(true);
    try {
      await api.post('/reports', { subject: subject.trim(), message: message.trim() });
      addToast(t('support.submitted'), 'success');
      navigate('/');
    } catch (error) {
      addToast(error.message, 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="page-card">
      <div className="page-header">
        <div>
          <p className="eyebrow">{t('support.eyebrow')}</p>
          <h2>{t('support.heading')}</h2>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="card form-card settings-form">
        <label>
          {t('support.subject')}
          <input autoFocus value={subject} onChange={(event) => setSubject(event.target.value)} placeholder={t('support.subjectPlaceholder')} />
        </label>
        <label>
          {t('support.message')}
          <textarea rows={5} value={message} onChange={(event) => setMessage(event.target.value)} placeholder={t('support.messagePlaceholder')} />
        </label>
        <button className="primary-btn standout-btn" type="submit" disabled={isSubmitting}>
          {isSubmitting ? t('support.submitting') : t('support.submit')}
        </button>
      </form>
    </section>
  );
}

export default ContactSupportPage;
